import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
import _extends from '/app/node_modules/babel-runtime/helpers/extends';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapActions, mapGetters, mapState } from 'vuex';
import { required, numeric, minLength, maxLength } from 'vuelidate/lib/validators';
import { stepForm } from '~/mixins';
import { GatewayTimeoutError, WarningError } from '~/abstractions/errors';
import { currencyTypeEnum, banks } from '~/enums';
import { different } from '~/validators';
import stringSplice from 'string-splice';
import leftPad from 'left-pad';
import loader from '../modals/loader';
import masks from '~~/jsons/masks.json';
// import { checkAccountNumberAlgorithm } from '~/plugins/account-number-algorithm'

export default {
    mixins: [stepForm],
    components: {
        loader: loader
    },
    data: function data() {

        console.log('Currency type', this.$store.state.affiliations.form.paymentData.currencyType);
        console.log(this.$store.state.affiliations.form.paymentData);
        console.log(this.$store.state['affiliations']['form']['paymentData']);
        var _$store$state$master = this.$store.state['master-data']['affiliation-in-process'],
            accountTypeSoles = _$store$state$master.accountTypeSoles,
            accountTypeDolares = _$store$state$master.accountTypeDolares;

        var _data = _extends({}, this.$store.state['affiliations']['form']['paymentData'], {
            scotiabankSolesCode: 'all',
            scotiabankDolaresCode: 'all',
            bbvaPrefix: '0011-',
            invalidAccountNumber: false,
            valid: false,
            multiple: false,
            mask: 'credit-card',
            loading: false,
            masks: masks,
            banks: banks,
            currencyTypeEnum: currencyTypeEnum,
            opCuentaSoles: accountTypeSoles,
            opCuentaDolares: accountTypeDolares,
            showErrorMessage: false,
            accountNumberSoles: this.$store.state.affiliations.form.paymentData.accountNumberSoles || '',
            accountNumberSolesAgent: this.$isCorresponsalia() && this.$store.state.affiliations.form.corresponsaliaData.header.bankAccount ? this.$store.state.affiliations.form.corresponsaliaData.header.bankAccount : '',
            sameAgentAccountSoles: false,
            accountNumberDolares: this.$store.state.affiliations.form.paymentData.accountNumberDolares || ''
            // _data.currencyType=_data.accountTypeDolares.IdTypeAccount!=null?2:1;

        });if (_data.accountTypeSoles.IdTypeAccount) _data.accountTypeSoles = accountTypeSoles.find(function (_ref) {
            var IdTypeAccount = _ref.IdTypeAccount;
            return IdTypeAccount === _data.accountTypeSoles.IdTypeAccount;
        });

        if (_data.accountTypeDolares.IdTypeAccount) _data.accountTypeDolares = accountTypeDolares.find(function (_ref2) {
            var IdTypeAccount = _ref2.IdTypeAccount;
            return IdTypeAccount === _data.accountTypeDolares.IdTypeAccount;
        });
        console.log(_data);
        return _data;
    },

    computed: _extends({
        isSoles: function isSoles() {
            return this.currencyType == this.currencyTypeEnum.SOLES || this.currencyType == this.currencyTypeEnum.SOLES_Y_DOLARES;
        },
        isDolares: function isDolares() {
            return this.currencyType == this.currencyTypeEnum.DOLARES || this.currencyType == this.currencyTypeEnum.SOLES_Y_DOLARES;
        }
    }, mapState({
        opBanks: function opBanks(state) {
            return state['master-data'].banks;
        },
        opAccounts: function opAccounts(state) {
            return state['master-data'].accountTypes;
        }
    }), mapGetters({
        opCoins: 'master-data/coins'
    }), {
        maskSoles: function maskSoles() {
            var _this = this;

            return !this.bankNameSoles || !this.accountTypeSoles ? [] : this.masks.filter(function (m) {
                return m.bancoid == _this.bankNameSoles.Code && m.tipo_cta == _this.accountTypeSoles.Name && m.moneda == _this.currencyTypeEnum.SOLES && (m.bancoid == _this.banks.SCOTIABANK ? 'all' == _this.scotiabankSolesCode || m.codigo == _this.scotiabankSolesCode : true) ? m : '';
            }).map(function (_ref3) {
                var formato_origen = _ref3.formato_origen;
                return formato_origen.replace(/9/g, '#');
            });
        },
        maskDolares: function maskDolares() {
            var _this2 = this;

            return !this.bankNameDolares || !this.accountTypeDolares ? [] : this.masks.filter(function (m) {
                return m.bancoid == _this2.bankNameDolares.Code && m.tipo_cta == _this2.accountTypeDolares.Name && m.moneda == _this2.currencyTypeEnum.DOLARES && (m.bancoid == _this2.banks.SCOTIABANK ? 'all' == _this2.scotiabankDolaresCode || m.codigo == _this2.scotiabankDolaresCode : true) ? m : '';
            }).map(function (_ref4) {
                var formato_origen = _ref4.formato_origen;
                return formato_origen.replace(/9/g, '#');
            });
        },
        isBBVASoles: function isBBVASoles() {
            return this.bankNameSoles === this.banks.BBVA;
        },
        isBBVADolares: function isBBVADolares() {
            return this.bankNameDolares === this.banks.BBVA;
        },
        isMaskSolesValid: function isMaskSolesValid() {
            return this.currencyType === this.currencyTypeEnum.DOLARES || this.maskSoles.map(function (m) {
                return m.length;
            }).indexOf(this.accountNumberSoles.length) > -1;
        },
        isMasAgentkSolesValid: function isMasAgentkSolesValid() {
            return this.currencyType === this.currencyTypeEnum.DOLARES || this.maskSoles.map(function (m) {
                return m.length;
            }).indexOf(this.accountNumberSoles.length) > -1;
        },
        isMaskDolaresValid: function isMaskDolaresValid() {
            return this.currencyType === this.currencyTypeEnum.SOLES || this.maskDolares.map(function (m) {
                return m.length;
            }).indexOf(this.accountNumberDolares.length) > -1;
        },
        sameNumberAccount: function sameNumberAccount() {
            if (this.accountNumberSoles === this.accountNumberDolares) {
                this.showErrorMessage = true;
                return true;
            } else {
                this.showErrorMessage = false;
                return false;
            }
        },
        maskSolesText: function maskSolesText() {
            return this.maskSoles.join(',');
        },
        maskDolaresText: function maskDolaresText() {
            return this.maskDolares.join(',');
        }
    }),
    validations: function validations() {

        var baseValidations = {
            currencyType: { required: required }
        };

        if (this.currencyType === this.currencyTypeEnum.SOLES) {
            baseValidations.accountNumberSoles = { required: required };
            baseValidations.bankNameSoles = { required: required };
            baseValidations.accountTypeSoles = { required: required };
        }
        if (this.currencyType === this.currencyTypeEnum.DOLARES) {
            baseValidations.accountNumberDolares = { required: required };
            baseValidations.bankNameDolares = { required: required };
            baseValidations.accountTypeDolares = { required: required };
        }
        if (this.$isCorresponsalia()) {
            baseValidations.accountNumberSolesAgent = {
                required: required,
                maxLength: maxLength(this.accountNumberSoles.length),
                minLength: minLength(this.accountNumberSoles.length)
            };
        }
        return baseValidations;
    },

    watch: {
        bankNameSoles: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(newVal, oldVal) {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!newVal) {
                                    _context.next = 4;
                                    break;
                                }

                                _context.next = 3;
                                return this.$store.dispatch('master-data/findAllTypeAccountByBank', {
                                    "idBank": newVal.IdBank,
                                    "code": newVal.Code
                                });

                            case 3:
                                this.opCuentaSoles = _context.sent;

                            case 4:
                                this.accountTypeSoles = '';
                                this.accountNumberSoles = '';

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function bankNameSoles(_x, _x2) {
                return _ref5.apply(this, arguments);
            }

            return bankNameSoles;
        }(),
        bankNameDolares: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(newVal, oldVal) {
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!newVal) {
                                    _context2.next = 4;
                                    break;
                                }

                                _context2.next = 3;
                                return this.$store.dispatch('master-data/findAllTypeAccountByBank', {
                                    "idBank": newVal.IdBank
                                });

                            case 3:
                                this.opCuentaDolares = _context2.sent;

                            case 4:
                                this.accountTypeDolares = '';
                                this.accountNumberDolares = '';

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function bankNameDolares(_x3, _x4) {
                return _ref6.apply(this, arguments);
            }

            return bankNameDolares;
        }(),
        accountTypeSoles: function accountTypeSoles() {
            this.accountNumberSoles = '';
        },
        accountTypeDolares: function accountTypeDolares() {
            this.accountNumberDolares = '';
        },
        currencyType: function currencyType(val) {
            console.log("val ", val);
            if (val === this.currencyTypeEnum.SOLES) {
                this.bankNameDolares = '';
                this.accountNumberDolares = '';
            } else if (val === this.currencyTypeEnum.DOLARES) {
                this.bankNameSoles = '';
                this.accountTypeSoles = '';
                this.accountNumberSoles = '';
            }
        },
        accountNumberSoles: function accountNumberSoles(newVal, oldVal) {
            if (this.bankNameSoles.Code !== this.banks.SCOTIABANK) return;

            // formato 99-999-999-9999-99
            if (this.scotiabankSolesCode == '15' && newVal.length >= 2) return;

            // formato 999-9999999
            if (this.scotiabankSolesCode == '19' && newVal.length >= 3) return;

            // formato 9999999
            if (this.scotiabankSolesCode == '17' && newVal.length >= 4) return;

            return this.scotiabankSolesCode = 'all';
        },
        accountNumberDolares: function accountNumberDolares(newVal, oldVal) {
            if (this.bankNameDolares.Code !== this.banks.SCOTIABANK) return;

            // formato 99-999-999-9999-99
            if (this.scotiabankDolaresCode == '16' && newVal.length >= 2) return;

            // formato 999-9999999
            if (this.scotiabankDolaresCode == '20' && newVal.length >= 3) return;

            // formato 9999999
            if (this.scotiabankDolaresCode == '18' && newVal.length >= 4) return;

            return this.scotiabankDolaresCode = 'all';
        }
    },
    methods: {
        loadAccountNumberSolesAgent: function loadAccountNumberSolesAgent() {

            this.accountNumberSolesAgent = this.sameAgentAccountSoles ? this.accountNumberSoles : '';
        },

        // removeLinesInAccountNumbers() {
        //     if (this.accountNumberSoles)
        //         this.accountNumberSoles = this.accountNumberSoles.replace(/-/g, '') 

        //     if (this.accountNumberDolares)
        //         this.accountNumberDolares = this.accountNumberDolares.replace(/-/g, '') 
        // },
        validateAccountNumber: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(currencyType, accountNumber, accountType, bank) {
                var _ref8, statusCode, internalStatusCode, internalStatusDescription, accountFormat;

                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.prev = 0;
                                _context3.next = 3;
                                return this.$store.dispatch('affiliations/form/validateBankAccountNumber', {
                                    currencyType: currencyType,
                                    accountNumber: accountNumber,
                                    accountType: accountType,
                                    bank: bank
                                });

                            case 3:
                                _ref8 = _context3.sent;
                                statusCode = _ref8.statusCode;
                                internalStatusCode = _ref8.internalStatusCode;
                                internalStatusDescription = _ref8.internalStatusDescription;
                                accountFormat = _ref8.accountFormat;

                                if (!(statusCode !== '0' || internalStatusCode !== '0000')) {
                                    _context3.next = 13;
                                    break;
                                }

                                _context3.t0 = internalStatusCode;
                                _context3.next = 12;
                                break;

                            case 12:
                                throw new WarningError(internalStatusDescription);

                            case 13:
                                _context3.t1 = currencyType;
                                _context3.next = _context3.t1 === this.currencyTypeEnum.SOLES ? 16 : _context3.t1 === this.currencyTypeEnum.DOLARES ? 18 : 20;
                                break;

                            case 16:
                                this.alternativeAccountNumberSoles = accountFormat;return _context3.abrupt('break', 20);

                            case 18:
                                this.alternativeAccountNumberDolares = accountFormat;return _context3.abrupt('break', 20);

                            case 20:
                                _context3.next = 27;
                                break;

                            case 22:
                                _context3.prev = 22;
                                _context3.t2 = _context3['catch'](0);

                                if (_context3.t2 instanceof GatewayTimeoutError) _context3.t2.message = 'Lo sentimos pero por el momento no podemos validar los datos de tu cuenta bancaria';

                                this.$controlMessage(_context3.t2);
                                throw _context3.t2;

                            case 27:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[0, 22]]);
            }));

            function validateAccountNumber(_x5, _x6, _x7, _x8) {
                return _ref7.apply(this, arguments);
            }

            return validateAccountNumber;
        }(),
        submit: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                var noApplyToCodeQR;
                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                noApplyToCodeQR = false;

                                this.$v.$touch();

                                if (!this.$v.invalid) {
                                    _context5.next = 4;
                                    break;
                                }

                                return _context5.abrupt('return');

                            case 4:

                                this.$nextTick(_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                                    var currencyType, accountNumberSoles, accountTypeSoles, bankSoles, accountNumberDolares, accountTypeDolares, bankDolares, accountNumber, accountType, bank, request;
                                    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                                        while (1) {
                                            switch (_context4.prev = _context4.next) {
                                                case 0:
                                                    this.loading = true;
                                                    this.$refs.loaderModal.showLoader();

                                                    // Ver mañana esto :VVVVVVV
                                                    currencyType = this.currencyType;

                                                    try {
                                                        this.$store.commit("affiliations/form/setCurrencyTypeBimoneda", currencyType);
                                                    } catch (error) {
                                                        this.$swal('Ocurrió un error al momento de Validar la Cuenta Bancaria, Vuelve a intentar', error.message || '', 'error');
                                                    }

                                                    _context4.prev = 4;

                                                    if (!(currencyType === this.currencyTypeEnum.SOLES_Y_DOLARES)) {
                                                        _context4.next = 22;
                                                        break;
                                                    }

                                                    accountNumberSoles = this.accountNumberSoles; //.replace(/-/g, '') 

                                                    accountTypeSoles = this.accountTypeSoles.Name;
                                                    bankSoles = this.bankNameSoles.Code;
                                                    _context4.next = 11;
                                                    return this.validateAccountNumber(this.currencyTypeEnum.SOLES, accountNumberSoles, accountTypeSoles, bankSoles);

                                                case 11:
                                                    _context4.next = 13;
                                                    return this.$store.dispatch("affiliations/form/sendDataBimoneda");

                                                case 13:
                                                    accountNumberDolares = this.accountNumberDolares; //.replace(/-/g, '') 

                                                    accountTypeDolares = this.accountTypeDolares.Name;
                                                    bankDolares = this.bankNameDolares.Code;
                                                    _context4.next = 18;
                                                    return this.validateAccountNumber(this.currencyTypeEnum.DOLARES, accountNumberDolares, accountTypeDolares, bankDolares);

                                                case 18:
                                                    _context4.next = 20;
                                                    return this.$store.dispatch("affiliations/form/modalityType", {
                                                        currencyType: currencyType
                                                    });

                                                case 20:
                                                    _context4.next = 33;
                                                    break;

                                                case 22:

                                                    // if (currencyType === this.currencyTypeEnum.SOLES || )
                                                    accountNumber = currencyType === this.currencyTypeEnum.SOLES ? this.accountNumberSoles : this.accountNumberDolares; //.replace(/-/g, '') 

                                                    accountType = (currencyType === this.currencyTypeEnum.SOLES ? this.accountTypeSoles : this.accountTypeDolares).Name;
                                                    bank = (currencyType === this.currencyTypeEnum.SOLES ? this.bankNameSoles : this.bankNameDolares).Code;


                                                    console.log('tipo moneda: ', currencyType, accountNumber, accountType, bank);
                                                    _context4.next = 28;
                                                    return this.validateAccountNumber(currencyType, accountNumber, accountType, bank);

                                                case 28:
                                                    if (!this.$isCorresponsalia()) {
                                                        _context4.next = 31;
                                                        break;
                                                    }

                                                    _context4.next = 31;
                                                    return this.validateAccountNumber(currencyType, this.accountNumberSolesAgent, accountType, bank);

                                                case 31:
                                                    _context4.next = 33;
                                                    return this.$store.dispatch("affiliations/form/modalityType", {
                                                        currencyType: currencyType
                                                    });

                                                case 33:

                                                    // if (this.$isVirtual())
                                                    //     checkAccountNumberAlgorithm(this)

                                                    // this.removeLinesInAccountNumbers()
                                                    // if (currencyType === this.currencyTypeEnum.DOLARES || currencyType === this.currencyTypeEnum.SOLES_Y_DOLARES) noApplyToCodeQR = true
                                                    if (this.currencyType === this.currencyTypeEnum.DOLARES || this.currencyType === this.currencyTypeEnum.SOLES_Y_DOLARES) noApplyToCodeQR = true;
                                                    // console.log('viendo si se habilita el codigo qr: ', noApplyToCodeQR)
                                                    request = {
                                                        data: {
                                                            currencyType: this.currencyType,
                                                            bankNameSoles: this.currencyType !== this.currencyTypeEnum.DOLARES && this.bankNameSoles !== "" ? this.bankNameSoles : '',
                                                            accountTypeSoles: this.currencyType !== this.currencyTypeEnum.DOLARES ? this.accountTypeSoles : '',
                                                            accountNumberSoles: this.currencyType !== this.currencyTypeEnum.DOLARES ? this.accountNumberSoles : '',
                                                            alternativeAccountNumberSoles: this.alternativeAccountNumberSoles || '',
                                                            bankNameDolares: this.currencyType !== this.currencyTypeEnum.SOLES && this.bankNameDolares.Code !== "" ? this.bankNameDolares : '',
                                                            accountTypeDolares: this.currencyType !== this.currencyTypeEnum.SOLES ? this.accountTypeDolares : '',
                                                            accountNumberDolares: this.currencyType !== this.currencyTypeEnum.SOLES ? this.accountNumberDolares : '',
                                                            alternativeAccountNumberDolares: this.alternativeAccountNumberDolares || '',
                                                            noApplyToCodeQR: noApplyToCodeQR
                                                        }
                                                    };

                                                    if (!this.$isCorresponsalia()) {
                                                        _context4.next = 38;
                                                        break;
                                                    }

                                                    _context4.next = 38;
                                                    return this.$store.dispatch("affiliations/form/saveBankAccountDataCorresponsalia", this.accountNumberSolesAgent);

                                                case 38:
                                                    _context4.next = 40;
                                                    return this.$store.dispatch("affiliations/form/saveBankAccountData", request);

                                                case 40:
                                                    _context4.next = 45;
                                                    break;

                                                case 42:
                                                    _context4.prev = 42;
                                                    _context4.t0 = _context4['catch'](4);

                                                    if (_context4.t0 instanceof GatewayTimeoutError) {
                                                        this.$swal('Ocurrió un error al conectar con el sistema de SAP', _context4.t0.message || '', 'error');
                                                    } else {
                                                        this.$controlMessage(_context4.t0);
                                                    }

                                                case 45:

                                                    this.loading = false;
                                                    this.$refs.loaderModal.closeLoader();

                                                case 47:
                                                case 'end':
                                                    return _context4.stop();
                                            }
                                        }
                                    }, _callee4, this, [[4, 42]]);
                                })));

                            case 5:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function submit() {
                return _ref9.apply(this, arguments);
            }

            return submit;
        }(),
        validateScotiabank: function validateScotiabank(evt, accountKey, scotiabankKey, bankKey) {

            if (this[bankKey].Code !== this.banks.SCOTIABANK || !accountKey) {
                return true;
            }

            var isSoles = scotiabankKey === 'scotiabankSolesCode';

            if ((isSoles ? this.maskSoles : this.maskDolares).length === 1) {
                return true;
            }
            if (this[bankKey].Code == banks.SCOTIABANK) {
                // validamos 2 dígitos y el '-' para el formato 99-999-999-9999-99
                if (this.isLine(evt) && this[accountKey].length === 2) {
                    this.$nextTick(function () {
                        this[accountKey] += '-';
                    });
                    return this[scotiabankKey] = isSoles ? '19' : '20';
                }

                // validamos 3 dígitos y el '-' para el formato 999-9999999
                if (this.isLine(evt) && this[accountKey].length === 3) {
                    this.$nextTick(function () {
                        this[accountKey] += '-';
                    });
                    return this[scotiabankKey] = isSoles ? '15' : '16';
                }

                // validamos 4 dígitos y no contiene el '-' para el formato 9999999
                if ((this[accountKey].length === 4 || this[accountKey].length === 3) && this[accountKey].indexOf('-') === -1) return this[scotiabankKey] = isSoles ? '17' : '18';
            }
        },
        isLine: function isLine(e) {
            return e.charCode === 45 || e.keyCode === 173 || e.key === '-';
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/bank-account-data.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/bank-account-data.vue
// module chunks = 0 1 2 3